import { gql } from '@apollo/client'

export const GOAL_GROUP_GRANTEES_INFO = gql`
  query goalGroupGranteesInfo($funderOrgId: Int!, $goalGroupId: Int!) {
    goalGroupGranteesInfo(
      funderOrgId: $funderOrgId
      goalGroupId: $goalGroupId
    ) {
      completedTasks
      goalName
      goalProgress
      goalTarget
      nonprofitOrgId
      totalTasks
    }
  }
`
